<template>
  <div class="device_task">
    <div class="logo">
      <div
        href="#"
        class="simple-text"
      >
        <div class="logo-img">
          <img
              src="/web/img/logo.png"
            alt=""
          >
        </div>
        {{ translate('esim_profile.reg') }}
      </div>
    </div>
    <div class="content">
      <form class="add_device-profile">
        <div class="row">
          <div class="col-md-12">
            <fg-input
              v-model="esim.imsi"
              type="text"
              label="IMSI"
              placeholder="IMSI"
            />
          </div>
          <div class="col-md-12 ">
            <fg-input
              v-model="esim.iccid"
              type="text"
              label="ICCID"
              placeholder="ICCID"
            />
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label> Data </label>
              <textarea class="input_text" type="text" name="" v-model="esim.data" />
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="submit"
            class="btn btn-success btn-wd"
            @click.prevent="proveEsim"
          >
            {{ translate('save') }}
          </button>
          <button
            class="btn btn-info btn-wd"
            @click.prevent="cancel"
          >
            {{ translate('to_cancel') }}
          </button>
        </div>
        <div class="clearfix" />
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EsimAdd',
  data () {
    return {
      esim: {
        imsi: '',
        iccid: '',
        data: '',
      }
    }
  },

  mounted () {
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    proveEsim () {
      if (this.esim.imsi === '') {
        this.global_notify('danger', this.translate('esim_profile.no_imsi'))
        return false
      }
      if (this.esim.iccid === '') {
        this.global_notify('danger', this.translate('esim_profile.no_iccid'))
        return false
      }
      if (this.esim.data === '') {
        this.global_notify('danger', this.translate('esim_profile.no_data'))
        return false
      }
      this.addDevice()
    },
    addDevice () {
      this.$http.simcard.addEsim(this.esim, (response) => {
        if (response.data.status) {
          this.global_notify('info', this.translate('esim_profile.registered'))
          this.$emit('update')

          let routeData = this.$router.resolve({name: 'esim_profile/' + response.data.id})
          window.open(routeData.href + routeData.location.name, '_self')

          this.$emit('close')
        }
      }, (bad_answer) => {
        this.bad_answer_handler(bad_answer)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
 .add_device-profile {
    margin: 18px;
    background-color: #ffffff;
    border-radius: 5px;
    padding: 15px;
    .input_text {
      height: 100%;
      resize: none;
      outline: none;
      width: 100%;
      background-color: #fffcf5;
      border-radius: 4px;
      color: #66615b;
      font-size: 14px;
      transition: background-color 0.3s ease 0s;
      padding: 7px 18px;
      box-shadow: none;
      border: 1px solid #e8e8e8;
    }
  }
</style>
